function findSizeInit(){
  const selectItems = document.querySelectorAll('.select__select option');

  var header = document.getElementById("unitS");
  var btns = header.getElementsByClassName("find-my-size__measurement-select");

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function(e) {
        e.preventDefault();
        var current = document.getElementsByClassName("active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
        
        var dataOption = e.target.getAttribute('data-fit-units');
        change(dataOption);
      });
    }

    function change(unit){
        selectItems.forEach((s, b)=>{
            var dataOption = s.getAttribute('data-units');
            
            if ( unit === dataOption ){
                s.style.display = 'block';
            } else{
                s.style.display = 'none';
            }
        });
    }

    const element = document.querySelector('form.find-my-size__form');
    const selectGroup = document.getElementById("ff-select");
    const resultWrap = document.getElementById("ff-results--wrapper");
    const resultItem = document.querySelector('.ff-result');

    const back = document.querySelector('.find-my-size--return');
    const hips = document.getElementById('hips');
    const bust = document.getElementById("bust");

    element.addEventListener('submit', function(event) {
      event.preventDefault();
      // actual logic, e.g. validate the form
      var bustInfo = bust.value;
        
      selectGroup.style.display = 'none';
      resultWrap.style.display = 'block';

      resultItem.innerHTML = bustInfo;

    });


    

    back.addEventListener('click', function(e){
      e.preventDefault();
      selectGroup.style.display = 'block';
      resultWrap.style.display = 'none';
      hips.selectedIndex = 0;
      bust.selectedIndex = 0;

      result.innerHTML = `<div class="visually-hidden">Size</div>`;
    });
}

findSizeInit();
if(window.location.href.indexOf('/pages/find-my-size') > -1) {
  findSizeInit();
}


